<template functional>
  <div
    :class="['club-logo', props.event ? 'club-logo__event-page' : '']"
    :style="props.parentStyle"
  >
    <img
      v-if="
        props.organiser && (props.organiser.logoUrl || props.organiser.logoPath)
      "
      :src="props.organiser.logoUrl || $options.url + props.organiser.logoPath"
      :alt="props.organiser.name + ' logo'"
      :class="props.small ? 'small' : ''"
      :style="props.imageStyle"
    />
    <template v-else>
      <img
        :src="parent.$federation.placeholderLogo"
        aria-hidden="true"
        :class="props.small ? 'small' : ''"
        :alt="
          props.organiser ? props.organiser.name + ' logo' : 'placeholder logo'
        "
        :style="props.imageStyle"
      />
    </template>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import gql from "fraql";
export default defineComponent({
  name: "AppOrganLogo",
  props: {
    organiser: {
      type: Object,
      default: null
    },
    event: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    parentStyle: {
      type: String,
      default: null
    },
    imageStyle: {
      type: String,
      default: null
    }
  },
  url: process.env.VUE_APP_API_URL,
  fragments: {
    organiser: gql`
      fragment _ on Organisation {
        id
        name
        logoPath
      }
    `
  }
});
</script>
<style scoped lang="scss">
.club-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  mix-blend-mode: multiply;

  img {
    display: flex;
    margin: auto;
    max-width: 150px;
    max-height: 150px;
    mix-blend-mode: multiply;
    &.small {
      justify-content: center;
      width: 80px !important;
      mix-blend-mode: multiply;
    }
  }
}
</style>
